import React from "react";
import { useSelector } from 'react-redux';
import { header } from "./Constants";
import Countries_Details from './Constants/index';
import { linkMap, countryDomain } from '../../../../Constants/index';
import { Body1, Subtitle } from 'src/Common/Theme/Typography/index';

function Countries() {
  const env = useSelector(
    (state) => state.HomePageReducer.env
  );

  return (
    <div className="countries-frame">
      <div className="wrapper-title">
        <Subtitle shopee bold className="title">
          {header}
        </Subtitle>
      </div>
      <div className="icons-container">
        {Countries_Details.map((data, idx) => (
          <div key={idx} className="icon-box">
            <div className="icon-elipsis">
              <div className="icons">
                {countryDomain[data.name] !== undefined ? (
                  <a href={linkMap[env] + countryDomain[data.name]}>
                    <img src={data.icon} alt="icon" />
                  </a>
                ) : (
                  <a href={linkMap[env] + '.com'}>
                    <img src={data.icon} alt="icon" />
                  </a>
                )}
              </div>
            </div>
            <Body1 openSans className="icon-text">{data.name}</Body1>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Countries;